import React from 'react';
import moment from 'moment';
import { FilledInput, FormControl, IconButton, InputAdornment, InputLabel } from '@mui/material';
import ControlPointTwoToneIcon from '@mui/icons-material/ControlPointTwoTone';
import RemoveCircleTwoToneIcon from '@mui/icons-material/RemoveCircleTwoTone';
import { useTailwindBrand } from '../shared';

interface Props {
    customDuration?: string;
    value?: any;
    label?: string;
    isPunctualMonth?: boolean;
    setDuration: React.Dispatch<React.SetStateAction<number>> | any;
    setEndTime?: React.Dispatch<any> | any;
    startTime?: any;
    duration: number;
}

const DurationFields = (props: Props) => {
    const { classes, brandConfig } = useTailwindBrand();

    const addDuration = () => {
        const max = props.isPunctualMonth ? 49.75 : 3.75;
        if (props.duration <= max) {
            props.setDuration((v: number) => v + 0.25);
            if (!props.isPunctualMonth) {
                props?.setEndTime(moment(props.startTime).add(props.duration + 0.25, 'hours'));
            }
        }
    };

    const removeDuration = () => {
        if (props.duration >= 0.5) {
            props.setDuration((v: number) => v - 0.25);
            if (!props.isPunctualMonth) {
                props?.setEndTime(moment(props.startTime).add(props.duration - 0.25, 'hours'));
            }
        }
    };

    return (
        <div className={`w-full ${props.customDuration ?? ''}`}>
            <FormControl variant="filled" fullWidth>
                <InputLabel className={`${classes.fontFamily} ${classes.text} font-semibold`}>
                    {props.label}
                </InputLabel>
                <FilledInput
                    readOnly
                    value={props.value ?? ''}
                    className={`${classes.fontFamily} bg-white rounded-md border border-gray-400`}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                type="button"
                                onClick={removeDuration}
                                disabled={props.duration <= 0.25}
                            >
                                <RemoveCircleTwoToneIcon sx={{ color: brandConfig.colors.primary }} />
                            </IconButton>
                            <IconButton
                                size="small"
                                type="button"
                                onClick={addDuration}
                                disabled={props.duration >= (props.isPunctualMonth ? 50 : 4)}
                            >
                                <ControlPointTwoToneIcon sx={{ color: brandConfig.colors.primary }} />
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>
        </div>
    );
};

export default DurationFields;
